module.exports = __webpack_public_path__ + "img/device_info.9b13d462.svg";